module.exports = __webpack_public_path__ + "static/img/stair-Img.8c86bcd829.png";